import React from "react";
import { Menu } from 'semantic-ui-react';


const LanguageSwitcher = ({lang, setActiveLanguage}) => {
  return (
    <Menu secondary>
         <Menu.Item
          name='Français'
          key='fr'
          style={{backgroundColor: lang === 'fr' ? '#6CADDF' : 'white', color: lang === 'fr' ?  'white' : 'black', boxShadow: "5px 8px 10px #00000029"}}
          active={lang === 'fr'}
          onClick={() => setActiveLanguage('fr')}
        />
        <Menu.Item
          name='English'
          key='en'
          style={{backgroundColor: lang === 'en' ? '#6CADDF' : 'white', color: lang === 'en' ?  'white' : 'black',  boxShadow: "5px 8px 10px #00000029"}}
          active={lang=== 'en'}
          onClick={() => setActiveLanguage('en')}
        />
        <Menu.Item
          name='Deútsche'
          key='de'
          style={{backgroundColor: lang === 'de' ? '#6CADDF' : 'white', color: lang === 'de' ?  'white' : 'black',  boxShadow: "5px 8px 10px #00000029"}}
          active={lang === 'de'}
          onClick={() => setActiveLanguage('de')}
        />
    </Menu>  
  );
}
export default LanguageSwitcher;